export default "Enter your email address and we will send you a link to reset your password."